// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — Floating Toolbar Above Selected Node
// ═══════════════════════════════════════════════════════════════

import { useI18n } from '../../../../i18n';

interface FloatingToolbarProps {
  x: number;
  y: number;
  onEdit: () => void;
  onAssignPerson: () => void;
  onCreateSubordinate: () => void;
  onDelete: () => void;
}

export function FloatingToolbar({
  x,
  y,
  onEdit,
  onAssignPerson,
  onCreateSubordinate,
  onDelete,
}: FloatingToolbarProps) {
  const { t } = useI18n();

  return (
    <div
      style={{
        position: 'absolute',
        left: x,
        top: y - 44,
        transform: 'translateX(-50%)',
        zIndex: 15,
        display: 'flex',
        gap: 2,
        background: '#fff',
        borderRadius: 8,
        boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
        padding: 4,
        border: '1px solid #E2E6ED',
      }}
    >
      <ToolbarBtn icon="✏" title={t.structure.editPuesto} onClick={onEdit} />
      <ToolbarBtn icon="👤" title={t.structure.assignPerson} onClick={onAssignPerson} />
      <ToolbarBtn icon="＋" title={t.structure.createSubordinate} onClick={onCreateSubordinate} />
      <div style={{ width: 1, background: '#E2E6ED', margin: '2px 2px' }} />
      <ToolbarBtn icon="🗑" title={t.structure.deletePuesto} onClick={onDelete} danger />
    </div>
  );
}

function ToolbarBtn({
  icon,
  title,
  onClick,
  danger,
}: {
  icon: string;
  title: string;
  onClick: () => void;
  danger?: boolean;
}) {
  return (
    <button
      onClick={onClick}
      title={title}
      style={{
        width: 32,
        height: 32,
        borderRadius: 6,
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        color: danger ? '#DC2626' : '#374151',
        transition: 'background 0.1s',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLElement).style.background = danger ? '#FEF2F2' : '#F3F4F6';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLElement).style.background = 'transparent';
      }}
    >
      {icon}
    </button>
  );
}
